import { handleActions } from 'redux-actions';
import { initState } from '../../../redux/models';
import * as actionType from './actionType';

export default handleActions(
  {
    //更新信息
    [actionType.ARRANGE_ROUTE_UPDATE]: (state, { data }) => {
      const newState = { ...state, ...data };
      return newState;
    },
    [actionType.ARRANGE_ROUTE_FILE]: state => {
      const newState = {
        ...state,
        modalTuttonLoading: false,
        tableLoading: false,
        exportLoading: false,
        multiplecusLoading: false,
        isSysAutoGenLinesLoading: false,
      };
      return newState;
    },
  },
  initState,
);
